const POPUP_CONFIG = {
  DEFAULT_CHECK_INTERVAL: 60,
  MAX_RETRIES: 100,
  WINDOW_FEATURES: {
    toolbar: 'no',
    location: 'no',
    directories: 'no',
    status: 'no',
    menubar: 'no',
    scrollbars: 'no',
    resizable: 'no',
    copyhistory: 'no'
  }
};

class PopupManager {
  constructor(config) {
    this.config = config;
  }

  createCenteredPopup(url, windowName, width, height) {
    const screenCenterY = window.top.innerHeight / 2 + window.top.screenY - (height / 2);
    const screenCenterX = window.top.innerWidth / 2 + window.top.screenX - (width / 2);

    const features = {
      ...POPUP_CONFIG.WINDOW_FEATURES,
      width,
      height,
      top: screenCenterY,
      left: screenCenterX
    };

    const featureString = Object.entries(features)
      .map(([key, value]) => `${key}=${value}`)
      .join(', ');

    return window.open(url, windowName, featureString);
  }

  async crossLogin(loginToken) {
    const casinoUrl = `${this.config.CASINO_API}/action?action=cross-login&token=${loginToken}&origin=bet`;
    console.log('casinoUrl', casinoUrl);
    const popupWindow = this.createCenteredPopup(casinoUrl, 'Casino777.es', 300, 200);

    // let retryCount = 0;
    //
    // const checkWindowStatus = () => {
    //   try {
    //     if (retryCount >= POPUP_CONFIG.MAX_RETRIES) {
    //       popupWindow.close();
    //       return;
    //     }
    //
    //     // Check if window is still accessible
    //     popupWindow.origin;
    //     retryCount++;
    //     setTimeout(checkWindowStatus, POPUP_CONFIG.DEFAULT_CHECK_INTERVAL);
    //   } catch (error) {
    //     popupWindow.close();
    //   }
    // };
    //
    // checkWindowStatus();
    return popupWindow;
  }
}

export default ({ app }, inject) => {
  // Create the popup manager instance with access to Nuxt config
  const popupManager = new PopupManager(app.$config);

  // Inject the popup manager into the Nuxt context as $popup
  inject('popup', popupManager);
};
